export const getOrdinalSuffix = (num: number): string => {
  const j = num % 10;
  const k = num % 100;
  if (j === 1 && k !== 11) return 'st';
  if (j === 2 && k !== 12) return 'nd';
  if (j === 3 && k !== 13) return 'rd';
  return 'th';
};

export const getOrdinal = (num: number): string => `${num}${getOrdinalSuffix(num)}`;

/**
 * Formats minutes since shift start into HH:MM format
 */
export const formatTimeFromMinutes = (minutes: number): string => {
  // Round to nearest minute to avoid floating point inaccuracies
  const totalMinutes = Math.round(minutes);
  const hours = Math.floor(totalMinutes / 60);
  const mins = totalMinutes % 60;
  return `${hours}:${mins.toString().padStart(2, '0')}`;
};

/**
 * Formats a time range from start minutes to end minutes in HH:MM - HH:MM format
 */
export const formatTimeRange = (startMinutes: number, endMinutes: number): string => {
  return `${formatTimeFromMinutes(startMinutes)} - ${formatTimeFromMinutes(endMinutes)}`;
};

// Utility to format minutes to "H hours and M minutes" or "X minutes"
export const formatMinutesHuman = (mins: number): string => {
    const h = Math.floor(mins / 60);
    const m = mins % 60;
    if (h > 0 && m > 0) return `${h} ${h === 1 ? 'hour' : 'hours'} and ${m} ${m === 1 ? 'minute' : 'minutes'}`;
    if (h > 0) return `${h} ${h === 1 ? 'hour' : 'hours'}`;
    return `${m} ${m === 1 ? 'minute' : 'minutes'}`;
};

// Helper function to format currency with conditional decimal places
export const formatCurrency = (amount: number): string => {
  const isWholeNumber = amount % 1 === 0;
  return amount.toLocaleString('en-US', {
    minimumFractionDigits: isWholeNumber ? 0 : 2,
    maximumFractionDigits: 2
  });
};

export const formatHours = (hours: number): string => {
  return hours.toLocaleString('en-US', {
    minimumFractionDigits: 0,
    maximumFractionDigits: 2,
  });
};
